// extracted by mini-css-extract-plugin
export default {"block":"oSnat3 mz-cancel-buttons","block--return":"OBwmnF","number":"WsHB4R","block--departing":"fbfICx","header":"TBS80c mz-compact-input__label"};